import React from 'react';

import * as ReactDOMServer from 'react-dom/server';
import { useClass } from '@breezerr';


type TextRotatorProps = {
    ContainerProps?: React.HTMLProps<HTMLSpanElement>;
    items: string[],
    // children: React.ReactElement;
    interval?: string | number;
    initialHeight?: number;
};

export const TextRotator = (props: TextRotatorProps) => {
    // const childrenHtml = ReactDOMServer.renderToStaticMarkup(props.children);
    // const items = childrenHtml.split('|').map(item => item.trim()).filter(item => !!item);
    const items = props.items;

    const interval = props.interval ? (typeof props.interval === 'string' ? parseFloat(props.interval) : props.interval) : 3

    const itemsRef = items.map(_ => React.useRef<HTMLSpanElement>(null));
    const intervalRef = React.useRef<number | null>(null);    

    const [active, setActive] = React.useState(0);
    const [height, setHeight] = React.useState(props.initialHeight || 0);
    const [width, setWidth] = React.useState<number | null>(null);
    
    const [ready, setReady] = React.useState(false);

    
    React.useEffect(() => {
        const element = itemsRef[active].current;

        if ( element !== null ) {
            const itemHeight = parseFloat(element.getBoundingClientRect().height.toFixed(2));
            const itemWidth = parseFloat(element.getBoundingClientRect().width.toFixed(2));

            setHeight(itemHeight);
            setWidth(itemWidth);

            setReady(true);
        }
    }, [active]);

    React.useEffect(() => {
        if ( typeof window !== 'undefined' ) {
            intervalRef.current = window.setInterval(() => {
                setActive((prev) => {
                    return prev >= items.length-1 ? 0 : prev + 1;
                });
            }, interval * 1000);

            return () => {
                if ( intervalRef.current !== null ) {
                    window.clearInterval(intervalRef.current);
                }
            }
        }
    }, []);

    return (
        <span {...props.ContainerProps}>
            <span className={useClass(`d-inline-flex flex-column align-items-start of-hidden h-${height}px ${width ? `w-${width.toFixed(0)}px` : ''}`)}>
                {items.map((item, index) => {
                    const move = ((active * 100) * -1).toFixed(2);
                    
                    return <span 
                        ref={itemsRef[index]} 
                        key={index}
                        style={{
                            display: 'inline',
                            transition: 'transform 150ms ease',
                            transform: `translateY(${move}%)`,
                            whiteSpace: 'nowrap',
                            paddingRight: '0.2rem',
                            width: index === 0 ? 'auto' : (!ready ? 0 : 'auto'),
                            visibility: index === 0 ? 'visible' : (ready ? 'visible' : 'hidden')
                        }}
                    >{ item }</span>
                })}
            </span>
        </span>
    );
};


export default TextRotator;